import ReactDOM from "react-dom";
import BaseComponent from "./BaseComponent";
import Button from "./Button";

export default class DualListBox extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            label: props.label,
            leftLabel: props.leftLabel,
            rightLabel: props.rightLabel,
            left: props.left ? props.left.sort((a, b) => a.value.localeCompare(b.value)) : [],
            right: props.right ? props.right.sort((a, b) => a.value.localeCompare(b.value)) : []
        };
        this.moveRight = this.moveRight.bind(this);
        this.moveLeft = this.moveLeft.bind(this);
    }

    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    moveRight() {
        const selectedOptions = this.getDomSelf().find("#left_list option:selected").toArray();
        this.getDomSelf().find(".list-select option:selected").prop("selected", false);
        const left = this.state.left.filter(l => !selectedOptions.some(ld => ld.value === l.id));
        const right = [
            ...this.state.right, ...selectedOptions.map(ld => {
                return {
                    id: ld.value,
                    value: ld.label
                }
            })
        ].sort((a, b) => a.value.localeCompare(b.value));
        this.updateContext({
            left: left.map(l => l.id),
            right: right.map(r => r.id),
            intentIds: selectedOptions.map(option => option.value)
        });
        this.setState({left, right});
    }

    moveLeft() {
        const selectedOptions = this.getDomSelf().find("#right_list option:selected").toArray();
        this.getDomSelf().find(".list-select option:selected").prop("selected", false);
        const right = this.state.right.filter(r => !selectedOptions.some(rd => rd.value === r.id));
        const left = [
            ...this.state.left, ...selectedOptions.map(rd => {
                return {
                    id: rd.value,
                    value: rd.label
                }
            })
        ].sort((a, b) => a.value.localeCompare(b.value));
        this.updateContext({
            left: left.map(l => l.id),
            right: right.map(r => r.id),
            intentIds: selectedOptions.map(option => option.value)
        });
        this.setState({left, right});
    }
    UNSAFE_componentWillReceiveProps(nextProps){
        // TODO: see also LoopHandling that needs this lifecycle method 
        if (nextProps.left) {
            this.setState({left: nextProps.left});
        }
        if (nextProps.right) {
            this.setState({right: nextProps.right});
        }
        nextProps.left.forEach(lt => {
            const currentLeftIndex= this.props.left.findIndex(l=>l.id===lt.id);
            if(currentLeftIndex===-1){
                this.props.context.setConfig(this.props.valKey);
            }
        });
        nextProps.right.forEach(lt => {
            const currentRightIndex= this.props.right.findIndex(l=>l.id===lt.id);
            if(currentRightIndex===-1){
                this.props.context.setConfig(this.props.valKey);
            }
        });
    }

    render() {
        return <div className={"form-component-container twinLists"}>
            {this.state.label &&
                <label data-tip={this.props.tooltip}>
                    {this.state.label}
                    {this.props.tooltip && <i className="fe icon-info"/>}
                </label>
            }
            <table align="center">
                <tbody>
                <tr>
                    <td className="list">
                        <div>
                            <div className="list-header">{this.state.leftLabel}</div>
                            <select id="left_list" className="list-select" size="10" multiple >
                                {this.state.left.length > 0 && this.state.left.map((item, idx) => {
                                    return <option value={item.id} key={"left" + idx}>
                                        {item.value}
                                    </option>
                                })}
                            </select>
                        </div>
                    </td>
                    <td className="divider">
                        <Button type={"small"} callback={this.moveRight} label=" > "/>
                        <Button type={"small"} callback={this.moveLeft} label=" < "/>
                    </td>
                    <td className="list">
                        <div>
                            <div className="list-header">{this.state.rightLabel}</div>
                            <select id="right_list" className="list-select" size="10" multiple >
                                {this.state.right.length > 0 && this.state.right.map((item, idx) => {
                                    return <option value={item.id} key={"right" + idx}>
                                        {item.value}
                                    </option>
                                })}
                            </select>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    }
}